import { hasValue } from "@cak-legacy/core-utils";
import { useTranslation } from "@cak-legacy/i18n-iprox";
import * as React from "react";

export interface IFallbackComponentProps {
  className?: string;
}
export const FallbackComponent: React.FC<IFallbackComponentProps> = (props) => {
  const { t } = useTranslation("fallback");

  const containerClassName = hasValue(props.className)
    ? `klantondersteuning-form-page-container ${props.className}`
    : "klantondersteuning-form-page-container";

  const introClassName = hasValue(props.className)
    ? `read-only-form intro ${props.className}--intro`
    : "read-only-form intro";

  return (
    <div className={containerClassName}>
      <h1 className="form-title form-title__reken-module">{t("title")}</h1>
      <div className="stepcounter-module"></div>
      <div className={introClassName}>
        <div className="intro-text intro">
          <div>
            <p>{t("text")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
